// extracted by mini-css-extract-plugin
export default {"notifications-header-container":"Notifications_notifications-header-container__bAG0j","notification-switch-text":"Notifications_notification-switch-text__Q0XNJ"};